<div
  class="wrapper"
  fxLayout="row"
  fxLayout.lt-md="column"
  fxLayoutAlign="space-between start"
>
  <div class="transportation-container" fxLayout="column" fxFlex="70">
    <div class="address-select">
      <h3>انتخاب آدرس</h3>
      <app-address-container
        [selectedAddress]="address"
        (onAddressSelect)="onAddressSelect($event)"
      ></app-address-container>

      <button (click)="addNewAddress()" mat-button color="primary">
        <span> اضافه کردن آدرس جدید </span>
        <jam-icon name="plus"></jam-icon>
      </button>
    </div>
    <br />

    <div class="transportation-method">
      <h3>روش ارسال</h3>
      <mat-radio-group
        aria-labelledby="روش ارسال سفارش"
        fxLayout="column"
        [(ngModel)]="transportationMethod"
      >
        <mat-radio-button
          class="transportation-radio-btn"
          *ngFor="let trans of transportationMethods"
          [disabled]="
            trans?.city?.name &&
            selectedAddress &&
            this.selectedAddress.city !== trans?.city?.name
          "
          [value]="trans"
          (change)="radioButtonChange($event)"
        >
          <span class="icon">
            <jam-icon [name]="trans.icon"></jam-icon>
          </span>
          <span class="name">
            {{ trans.name }}
          </span>
          <span class="desc" *ngIf="trans?.desc"> ({{ trans.desc }} ) </span>
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <!--
  <div class="voucher-code">
    <payment-voucher-input [(voucher)]="voucherCode"></payment-voucher-input>
  </div> -->

  <shopping-cart-payment-status
    [disabled]="!readyForNextLevel"
    [status]="generateStatus()"
    (submit)="this.submit()"
    [transportMethod]="transportationMethod"
    fxFlex="28"
  ></shopping-cart-payment-status>
</div>
